const F2 = 0.3660254037844386;
const G2 = 0.21132486540518713;
const GRAD3: readonly (readonly [number, number])[] = [
  [1, 1], [-1, 1], [1, -1], [-1, -1],
  [1, 0], [-1, 0], [1, 0], [-1, 0],
  [0, 1], [0, -1], [0, 1], [0, -1],
];

function contrib(t: number, x: number, y: number, g: readonly [number, number]): number {
  if (t < 0) return 0;
  t *= t;
  return t * t * (g[0] * x + g[1] * y);
}

export class Noise {
  private readonly perm = new Int32Array(512);

  constructor(seed: number) {
    const p = new Int32Array(256);
    for (let i = 0; i < 256; i++) p[i] = i;
    let s = seed >>> 0;
    if (s === 0) s = 0x9e3779b9;
    const next = (): number => {
      s ^= s << 13; s >>>= 0;
      s ^= s >>> 17; s >>>= 0;
      s ^= s << 5; s >>>= 0;
      return s;
    };
    for (let i = 255; i > 0; i--) {
      const j = next() % (i + 1);
      const tmp = p[i]!; p[i] = p[j]!; p[j] = tmp;
    }
    for (let i = 0; i < 512; i++) this.perm[i] = p[i & 255]!;
  }

  eval(xin: number, yin: number): number {
    const perm = this.perm;
    const s = (xin + yin) * F2;
    const i = Math.floor(xin + s);
    const j = Math.floor(yin + s);
    const t = (i + j) * G2;
    const x0 = xin - (i - t);
    const y0 = yin - (j - t);
    let i1 = 0, j1 = 1;
    if (x0 > y0) { i1 = 1; j1 = 0; }
    const x1 = x0 - i1 + G2;
    const y1 = y0 - j1 + G2;
    const x2 = x0 - 1 + 2 * G2;
    const y2 = y0 - 1 + 2 * G2;
    const ii = i & 255;
    const jj = j & 255;
    const gi0 = perm[ii + perm[jj]!]! % 12;
    const gi1 = perm[ii + i1 + perm[jj + j1]!]! % 12;
    const gi2 = perm[ii + 1 + perm[jj + 1]!]! % 12;
    const n0 = contrib(0.5 - x0 * x0 - y0 * y0, x0, y0, GRAD3[gi0]!);
    const n1 = contrib(0.5 - x1 * x1 - y1 * y1, x1, y1, GRAD3[gi1]!);
    const n2 = contrib(0.5 - x2 * x2 - y2 * y2, x2, y2, GRAD3[gi2]!);
    return 70 * (n0 + n1 + n2);
  }
}
